<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-evgImport-wmWeekPoImport',
  components: { PageTable },
}
</script>
